import type { MouseEvent } from 'react';
import classNames from 'classnames';

import IconButton from 'components/partials/button/icon-button';

import { useMarkSurface } from '../mark-surface-context';
import type { MarkContextTarget } from '../mark-panel.types';

import MarkEmblem from './mark-emblem';

export interface MarkContextTriggerProps {
  target: MarkContextTarget;
  ariaLabel: string;
  className?: string;
}

const MarkContextTrigger = ({
  target,
  ariaLabel,
  className,
}: MarkContextTriggerProps) => {
  const markSurface = useMarkSurface();

  if (!markSurface) return null;

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    markSurface.requestOpen(target, event.currentTarget);
  };

  return (
    <IconButton
      variant="reserve-text"
      size="md"
      icon={<MarkEmblem />}
      aria-label={ariaLabel}
      onClick={handleClick}
      className={classNames(
        'size-5 !p-0 !border-0 !rounded-full opacity-0 transition-opacity group-hover:opacity-100 group-has-[:focus-visible]:opacity-100',
        className
      )}
    />
  );
};

export default MarkContextTrigger;
